<div class="grid grid-cols-2 gap-3 p-3 bg-gray-100">
  <div class="action">
    <tgsd-screen-reader></tgsd-screen-reader>
  </div>
  <div class="action">
    <tgsd-contrast></tgsd-contrast>
  </div>
  <div class="action">
    <tgsd-saturate></tgsd-saturate>
  </div>
  <div class="action">
    <tgsd-text-size></tgsd-text-size>
  </div>
  <div class="action">
    <tgsd-text-spacing></tgsd-text-spacing>
  </div>
  <div class="action">
    <tgsd-screen-mask></tgsd-screen-mask>
  </div>
  <div class="action">
    <tgsd-line-height></tgsd-line-height>
  </div>
  <div class="action">
    <tgsd-text-align></tgsd-text-align>
  </div>
  <div class="action">
    <tgsd-pause-animations></tgsd-pause-animations>
  </div>
  <div class="action">
    <tgsd-highlight-links></tgsd-highlight-links>
  </div>
  <div class="action">
    <tgsd-hide-images></tgsd-hide-images>
  </div>
  <div class="action">
    <tgsd-dyslexia-friendly></tgsd-dyslexia-friendly>
  </div>
<!--  <div class="action">-->
<!--    <tgsd-invert></tgsd-invert>-->
<!--  </div>-->
</div>


